import { Filters } from "../../common/generators/filters";
import {
  FilterInput,
  BaseFiltersInput,
  UserFiltersInput,
  UserItem
} from "@core/store/types/common/statistic/generic/statisticFilters";
import { WebmastersFilterService } from "@core/services/common/lists/WebmastersFilterService";

export class WebmastersFilters extends Filters<UserItem, BaseFiltersInput> {
  getData = async (offset: number, limit: number, filters: UserFiltersInput, initialFilters: BaseFiltersInput) => {
    // @ts-ignore
    const { excludedFilterOptions, ...otherFilters } = filters;
    const { data: { webmasters, initialWebmasters } } =
      await WebmastersFilterService.getWebmastersFilters(offset, limit, otherFilters, excludedFilterOptions, initialFilters);
    
    return {
      data: {
        items: webmasters?.items,
        count: webmasters?.count
      },
      initialData: {
        items: initialWebmasters?.items,
        count: initialWebmasters?.length
      }
    };
  }
  
  getInitialFilters = (ids?: Array<string> | string): FilterInput | undefined => {
    if (ids) {
      const id = Array.isArray(ids) ? ids : [ids];
      return { id };
    }
  };
}